/**
 * CAPPONI — aviso de vuelta a stock por talla.
 *
 * Observa la variante seleccionada en la ficha; si está agotada, muestra el
 * botón de la campanita. El envío llama a la API pública de Back in Stock de
 * Klaviyo con el id de variante de Shopify. Sin dependencias del theme: se
 * relee el input oculto del formulario de producto tras cada interacción,
 * que sobrevive a los re-renders por secciones de Horizon.
 */
(function () {
  if (window.__capponiAvisameInit) return;
  window.__capponiAvisameInit = true;

  var REVISION = '2024-10-15';

  function raiz() {
    return document.querySelector('[data-capponi-avisame]');
  }

  function variantes(caja) {
    try {
      return JSON.parse(caja.querySelector('[data-avisame-variantes]').textContent);
    } catch (e) {
      return null;
    }
  }

  function varianteSeleccionada(caja) {
    var seccion = caja.closest('.shopify-section') || document;
    var input = seccion.querySelector('product-form-component input[name="id"], form[action*="/cart/add"] input[name="id"]');
    return input ? String(input.value) : null;
  }

  // Solo toca el DOM cuando el estado cambia de verdad: el observer de abajo
  // reacciona a mutaciones y sin estas guardas se retroalimentaría.
  function ponerOculto(caja, oculto) {
    if (caja.hasAttribute('hidden') !== oculto) {
      if (oculto) caja.setAttribute('hidden', '');
      else caja.removeAttribute('hidden');
    }
  }

  function actualizar() {
    var caja = raiz();
    if (!caja) return;
    var mapa = variantes(caja);
    var id = varianteSeleccionada(caja);
    if (!mapa || !id || !mapa[id] || mapa[id].disponible) {
      ponerOculto(caja, true);
      return;
    }
    ponerOculto(caja, false);
    if (caja.dataset.variante !== id) caja.dataset.variante = id;
    var etiqueta = caja.querySelector('[data-avisame-etiqueta]');
    var texto = 'AVÍSAME CUANDO VUELVA · TALLA ' + mapa[id].talla;
    if (etiqueta && etiqueta.textContent !== texto) etiqueta.textContent = texto;
  }

  // La selección de talla re-renderiza la sección (morph) DESPUÉS del click y
  // vuelve a pintar el bloque con el hidden de servidor: hay que re-evaluar
  // tras cada mutación de la sección, no solo tras la interacción.
  var timer = null;
  function programar() {
    clearTimeout(timer);
    timer = setTimeout(actualizar, 150);
  }

  ['click', 'change'].forEach(function (tipo) {
    document.addEventListener(tipo, programar);
  });

  var observador = new MutationObserver(programar);
  function observar() {
    var caja = raiz();
    if (!caja) return;
    var seccion = caja.closest('.shopify-section') || document.body;
    observador.observe(seccion, { childList: true, subtree: true, attributes: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      actualizar();
      observar();
    });
  } else {
    actualizar();
    observar();
  }

  document.addEventListener('click', function (ev) {
    var abrir = ev.target.closest('[data-avisame-abrir]');
    if (!abrir) return;
    ev.preventDefault();
    var caja = abrir.closest('[data-capponi-avisame]');
    // Sin autofoco: el anillo de foco engordaba la caja del email nada más
    // abrirse. El campo se enfoca cuando el cliente lo toca.
    var abierto = caja.classList.toggle('is-abierto');
    abrir.setAttribute('aria-expanded', abierto ? 'true' : 'false');
  });

  document.addEventListener('submit', async function (ev) {
    var form = ev.target.closest('[data-avisame-form]');
    if (!form) return;
    ev.preventDefault();
    var caja = form.closest('[data-capponi-avisame]');
    var ok = caja.querySelector('[data-avisame-ok]');
    var error = caja.querySelector('[data-avisame-error]');
    var boton = form.querySelector('.capponi-avisame__enviar');
    var email = form.querySelector('input[type="email"]').value.trim();
    var variante = caja.dataset.variante;
    if (!email || !variante) return;

    if (error) error.setAttribute('hidden', '');
    if (boton) boton.disabled = true;

    var cuerpo = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: { type: 'profile', attributes: { email: email } },
          },
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + variante,
            },
          },
        },
      },
    };

    try {
      var r = await fetch(
        'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' +
          encodeURIComponent(caja.dataset.clave),
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: REVISION },
          body: JSON.stringify(cuerpo),
        }
      );
      if (r.status >= 200 && r.status < 300) {
        caja.classList.remove('is-abierto');
        var abrir = caja.querySelector('[data-avisame-abrir]');
        if (abrir) abrir.setAttribute('hidden', '');
        if (ok) ok.removeAttribute('hidden');
        return;
      }
      throw new Error('estado ' + r.status);
    } catch (e) {
      if (error) error.removeAttribute('hidden');
    } finally {
      if (boton) boton.disabled = false;
    }
  });
})();
